import toast from 'react-hot-toast';

/**
 * Show a success toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options
 */
export const showSuccess = (message, options = {}) => {
  toast.success(message, {
    duration: 4000,
    position: 'top-right',
    ...options
  });
};

/**
 * Show an error toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options
 */
export const showError = (message, options = {}) => {
  toast.error(message, {
    duration: 5000,
    position: 'top-right',
    ...options
  });
};

/**
 * Show a warning toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options
 */
export const showWarning = (message, options = {}) => {
  toast(message, {
    duration: 4500,
    position: 'top-right',
    icon: '⚠️',
    style: {
      borderRadius: '10px',
      background: '#fff8e6',
      color: '#6b5900',
    },
    ...options
  });
};

/**
 * Show a confirmation dialog using browser's confirm dialog
 * @param {string} title - The title of the confirmation dialog
 * @param {string} message - The message to display
 * @param {string} confirmText - Text for the confirm button (default: 'OK')
 * @param {string} cancelText - Text for the cancel button (default: 'Cancel')
 * @returns {Promise<boolean>} - Resolves to true if confirmed, false if cancelled
 */
export const showConfirm = async (title = 'Confirm Action', message, confirmText = 'OK', cancelText = 'Cancel') => {
  // For now, use browser's native confirm dialog for simplicity and reliability
  // In the future, this can be replaced with a custom modal component
  const fullMessage = title + '\n\n' + message;
  return window.confirm(fullMessage);
};
